import * as React from 'react';

import {AiUsageSection} from '.';

type Props = {
    isEnabled: boolean;
    setIsEnabled: (isEnabled: boolean) => void;
};

export function AiTranscriptionSection(props: Props) {
    return (
        <AiUsageSection
            setIsEnabled={props.setIsEnabled}
            isEnabled={props.isEnabled}
            description='Enable notetaker for transcription.'
            title='Transcription usage'
            link='https://support.nutshell.com/en/articles/10485878-ai-how-to-use-nutshell-s-notetaker'
            alternateUsageSummary='Use Notetaker to assist you in transcribing messages. Speak your notes and Nutshell will do the typing.'
            unit={'transcriptions'}
        />
    );
}
